import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../AirlinePartner/AirlinesDetail.css";
import { Link } from "react-router-dom";
import FlightDeal from "../FlightDeals/FlightDeals";
import DestinationDeals from "../Destination/DestinationDeal";

// Mapping airlines to their specific destinations
const airlineDestinations = {
  british: ["usa", "canada", "caribbean"],
  emirates: ["middle-east", "indian-ocean", "far-east", "australia"],
  singapore: ["far-east", "australia", "new-zealand", "indian-ocean"],
  virginatlantic: ["usa", "caribbean", "south-africa"],
  qatar: ["middle-east", "indian-ocean", "far-east", "south-africa"],
  cathaypacific: ["far-east", "australia", "new-zealand"],
  united: ["usa", "canada", "south-america"],
  american: ["usa", "canada", "caribbean", "south-america"],
  etihad: ["middle-east", "indian-ocean", "far-east", "australia"],
  "air-newzealand": ["new-zealand", "australia", "caribbean"],
  "malaysia-airlines": ["far-east", "australia", "south-africa"],
  "garuda-indonesia": ["far-east", "indian-ocean", "middle-east"],
  swiss: ["australia", "usa", "south-america"],
  delta: ["usa", "canada", "middle-east"],
  klm: ["canada", "australia", "caribbean"],
  "eva-air": ["far-east", "south-america", "australia"],
  ana: ["usa", "far-east", "middle-east"],
};

const destinationData = {
  australia: [
    {
      city: "Adelaide",
      firstClass: 3296,
      businessClass: 2120,
      premiumEconomy: 1240,
      economy: 648,
      image: "/au1.jpg",
      link: "/destination/australia",
    },
    {
      city: "Brisbane",
      firstClass: 3424,
      businessClass: 1972,
      premiumEconomy: 1264,
      economy: 704,
      image: "/au2.jpg",
      link: "/destination/australia",
    },
    {
      city: "Cairns",
      firstClass: 3520,
      businessClass: 2544,
      premiumEconomy: 1340,
      economy: 708,
      image: "/au3.jpg",
      link: "/destination/australia",
    },
  ],
  canada: [
    {
      city: "Toronto",
      firstClass: 3600,
      businessClass: 2400,
      premiumEconomy: 1440,
      economy: 760,
      image: "/ca1.jpg",
      link: "/destination/canada",
    },
    {
      city: "Vancouver",
      firstClass: 3680,
      businessClass: 2480,
      premiumEconomy: 1520,
      economy: 784,
      image: "/ca2.jpg",
      link: "/destination/canada",
    },
    {
      city: "Montreal",
      firstClass: 3760,
      businessClass: 2560,
      premiumEconomy: 1600,
      economy: 816,
      image: "/ca3.jpg",
      link: "/destination/canada",
    },
  ],
  caribbean: [
    {
      city: "Barbados",
      firstClass: 3840,
      businessClass: 2480,
      premiumEconomy: 1360,
      economy: 680,
      image: "/car1.jpg",
      link: "/destination/caribbean",
    },
    {
      city: "Jamaica",
      firstClass: 3760,
      businessClass: 2560,
      premiumEconomy: 1280,
      economy: 720,
      image: "/car2.jpg",
      link: "/destination/caribbean",
    },
    {
      city: "Bahamas",
      firstClass: 3920,
      businessClass: 2640,
      premiumEconomy: 1440,
      economy: 736,
      image: "/car3.jpg",
      link: "/destination/caribbean",
    },
  ],
  "far-east": [
    {
      city: "Tokyo",
      firstClass: 4240,
      businessClass: 3200,
      premiumEconomy: 1680,
      economy: 880,
      image: "/far1.jpg",
      link: "/destination/far-east",
    },
    {
      city: "Bangkok",
      firstClass: 3840,
      businessClass: 2800,
      premiumEconomy: 1600,
      economy: 760,
      image: "/far2.jpg",
      link: "/destination/far-east",
    },
    {
      city: "Singapore",
      firstClass: 4160,
      businessClass: 2960,
      premiumEconomy: 1760,
      economy: 800,
      image: "/far3.jpg",
      link: "/destination/far-east",
    },
  ],
  "indian-ocean": [
    {
      city: "Maldives",
      firstClass: 4800,
      businessClass: 3600,
      premiumEconomy: 1920,
      economy: 960,
      image: "/io1.webp",
      link: "/destination/indian-ocean",
    },
    {
      city: "Mauritius",
      firstClass: 4400,
      businessClass: 3360,
      premiumEconomy: 1840,
      economy: 880,
      image: "/io2.avif",
      link: "/destination/indian-ocean",
    },
    {
      city: "Seychelles",
      firstClass: 4640,
      businessClass: 3520,
      premiumEconomy: 2000,
      economy: 920,
      image: "/io3.jpg",
      link: "/destination/indian-ocean",
    },
  ],
  "middle-east": [
    {
      city: "Dubai",
      firstClass: 4560,
      businessClass: 3040,
      premiumEconomy: 1680,
      economy: 760,
      image: "/me1.jpg",
      link: "/destination/middle-east",
    },
    {
      city: "Abu Dhabi",
      firstClass: 4480,
      businessClass: 2960,
      premiumEconomy: 1760,
      economy: 800,
      image: "/me2.webp",
      link: "/destination/middle-east",
    },
    {
      city: "Doha",
      firstClass: 4400,
      businessClass: 2880,
      premiumEconomy: 1600,
      economy: 720,
      image: "/me3.webp",
      link: "/destination/middle-east",
    },
  ],
  "new-zealand": [
    {
      city: "Auckland",
      firstClass: 3680,
      businessClass: 2560,
      premiumEconomy: 1600,
      economy: 800,
      image: "/nz1.jpg",
      link: "/destination/new-zealand",
    },
    {
      city: "Wellington",
      firstClass: 3760,
      businessClass: 2640,
      premiumEconomy: 1680,
      economy: 840,
      image: "/nz2.webp",
      link: "/destination/new-zealand",
    },
    {
      city: "Christchurch",
      firstClass: 3840,
      businessClass: 2720,
      premiumEconomy: 1760,
      economy: 880,
      image: "/nz3.jpg",
      link: "/destination/new-zealand",
    },
  ],
  "south-africa": [
    {
      city: "Cape Town",
      firstClass: 4080,
      businessClass: 2960,
      premiumEconomy: 1680,
      economy: 760,
      image: "/sa1.webp",
      link: "/destination/south-africa",
    },
    {
      city: "Johannesburg",
      firstClass: 4160,
      businessClass: 3040,
      premiumEconomy: 1760,
      economy: 800,
      image: "/sa2.jpg",
      link: "/destination/south-africa",
    },
    {
      city: "Durban",
      firstClass: 4240,
      businessClass: 3120,
      premiumEconomy: 1840,
      economy: 840,
      image: "/sa3.jpeg",
      link: "/destination/south-africa",
    },
  ],
  "south-america": [
    {
      city: "Rio de Janeiro",
      firstClass: 4480,
      businessClass: 3280,
      premiumEconomy: 1840,
      economy: 920,
      image: "/sm1.jpg",
      link: "/destination/south-america",
    },
    {
      city: "Buenos Aires",
      firstClass: 4320,
      businessClass: 3200,
      premiumEconomy: 1760,
      economy: 880,
      image: "/sm2.webp",
      link: "/destination/south-america",
    },
    {
      city: "Lima",
      firstClass: 4400,
      businessClass: 3360,
      premiumEconomy: 1800,
      economy: 840,
      image: "/sm3.jpg",
      link: "/destination/south-america",
    },
  ],
  usa: [
    {
      city: "New York",
      firstClass: 3840,
      businessClass: 2720,
      premiumEconomy: 1680,
      economy: 880,
      image: "/usa1.jpg",
      link: "/destination/usa",
    },
    {
      city: "Los Angeles",
      firstClass: 3920,
      businessClass: 2800,
      premiumEconomy: 1760,
      economy: 920,
      image: "/usa2.webp",
      link: "/destination/usa",
    },
    {
      city: "Chicago",
      firstClass: 3760,
      businessClass: 2640,
      premiumEconomy: 1600,
      economy: 800,
      image: "/usa3.jpg",
      link: "/destination/usa",
    },
  ],
};

const airlines = [
  {
    id: "british",
    airline: "British Airways",
    business: "£2235",
    first: "£3256",

    details:
      "British Airways offers luxurious flights with impeccable service and comfort. Whether you're flying to Europe, the Americas, or Asia, British Airways provides a premium experience with personalized service, world-class amenities, and excellent in-flight entertainment.",
    heading: "Fly with British Airways",
    text: "Experience the epitome of luxury with British Airways, offering both business and first-class services that guarantee comfort and style. With their extensive network, British Airways connects you to the world with the best in-flight experience.",
    subtext: "A premium choice for global travel.",
    airlineImage: "/british.jpg",
    experienceImage: "/britishe.jpg",
    about:
      "British Airways, the UK's national airline, is known for its exceptional service and state-of-the-art aircraft. It offers a luxurious and comfortable flying experience to destinations all around the globe.",
  },
  {
    id: "emirates",
    airline: "Emirates",
    business: "£2560",
    first: "£3600",

    details:
      "Emirates is renowned for its exceptional service and luxury, offering the finest cabins in the skies. From the moment you board, you'll be treated to world-class amenities, gourmet dining, and excellent entertainment.",
    heading: "Experience Luxury with Emirates",
    text: "Emirates is the airline of choice for luxury travelers. Whether you're in business class or first class, Emirates ensures a top-tier flying experience, with the finest food, entertainment, and customer service available.",
    subtext: "For those who desire luxury in the skies.",
    airlineImage: "/emirates.jpg",
    experienceImage: "/emiratese.jpg",
    about:
      "Emirates, based in Dubai, is famous for its premium service, luxurious cabins, and excellent customer care. It's the airline that redefines air travel with style and elegance.",
  },
  {
    id: "singapore",
    airline: "Singapore Airlines",
    business: "£2480",
    first: "£3520",

    details:
      "Singapore Airlines is globally recognized for its premium service and comfort. With a focus on customer care, Singapore Airlines offers one of the most luxurious flight experiences available, from exceptional food to unparalleled in-flight entertainment.",
    heading: "Fly in Style with Singapore Airlines",
    text: "Singapore Airlines is a leader in the aviation industry, offering one of the most comfortable flying experiences. Whether in business or first class, you’ll enjoy luxury, comfort, and world-class service throughout your journey.",
    subtext: "For travelers who value elegance and comfort.",
    airlineImage: "/singapore.jpg",
    experienceImage: "/singaporee.jpg",
    about:
      "Singapore Airlines is known for its luxurious flights and excellent customer service. With a strong global network, it connects travelers to a range of destinations with unmatched comfort.",
  },
  {
    id: "virginatlantic",
    airline: "Virgin Atlantic",
    business: "£2240",
    first: "£3200",

    details:
      "Virgin Atlantic is a global airline that offers exceptional service and comfortable seating. From world-class entertainment to delicious food, Virgin Atlantic ensures a premium travel experience for business and first-class passengers.",
    heading: "Fly with Virgin Atlantic",
    text: "Virgin Atlantic offers an exciting travel experience with luxurious amenities. Their business and first-class cabins provide ample space, top-tier food, and award-winning entertainment, making your journey as comfortable as possible.",
    subtext: "A fun and luxurious way to travel.",
    airlineImage: "/virginatlantic.jpg",
    experienceImage: "/virginatlantice.jpg",
    about:
      "Virgin Atlantic is known for its trendy approach to air travel, offering chic and stylish services with a focus on comfort and luxury. Their commitment to quality service makes them one of the leading airlines in the world.",
  },
  {
    id: "qatar",
    airline: "Qatar Airways",
    business: "£2400",
    first: "£3360",

    details:
      "Qatar Airways is synonymous with luxury and comfort. With its spacious seats, superb dining, and excellent in-flight entertainment, Qatar Airways sets the standard for five-star travel.",
    heading: "Travel in Luxury with Qatar Airways",
    text: "As one of the best airlines in the world, Qatar Airways offers unparalleled luxury with its exceptional business and first-class cabins. Enjoy personalized service, top-quality food, and the most comfortable travel experience imaginable.",
    subtext: "For those who demand nothing but the best.",
    airlineImage: "/qatar.jpg",
    experienceImage: "/qatare.jpg",
    about:
      "Qatar Airways is a global leader in luxury travel, with a reputation for providing the finest air travel experience. From their world-class service to their modern fleet, Qatar Airways is the perfect choice for discerning travelers.",
  },
  {
    id: "cathaypacific",
    airline: "Cathay Pacific",
    business: "£2160",
    first: "£3280",

    details:
      "Cathay Pacific is known for its premium service and comfort, offering an exceptional experience in both business and first class. With superb amenities, fine dining, and outstanding entertainment, Cathay Pacific makes every journey enjoyable.",
    heading: "Fly with Cathay Pacific",
    text: "Cathay Pacific is one of Asia's premier airlines, providing luxury services and impeccable customer care. Their cabins are designed with comfort in mind, making sure that your journey is as pleasant and relaxing as possible.",
    subtext: "Experience exceptional service with Cathay Pacific.",
    airlineImage: "/cathaypacific.jpg",
    experienceImage: "/cathaypacifice.jpg",
    about:
      "Cathay Pacific offers luxurious and comfortable flights with top-class amenities. It’s a premium airline that’s known for its world-class service and modern aircraft.",
  },
  {
    id: "united",
    airline: "United Airlines",
    business: "£2080",
    first: "£3040",

    details:
      "United Airlines offers a reliable and premium flying experience with excellent service. Whether you're flying to the U.S. or international destinations, United ensures comfort, great food, and entertainment on every flight.",
    heading: "Fly Across the Globe with United Airlines",
    text: "United Airlines offers both business and first-class services designed for comfort and convenience. With an extensive flight network, you’ll find luxurious flights to destinations worldwide.",
    subtext: "A global airline with premium service.",
    airlineImage: "/united.jpg",
    experienceImage: "/unitede.jpg",
    about:
      "United Airlines is a major American airline that connects you to thousands of destinations around the world with a focus on comfort and quality service.",
  },
  {
    id: "american",
    airline: "American Airlines",
    business: "£2000",
    first: "£2960",

    details:
      "American Airlines offers a comprehensive flight experience with top-notch service. Known for its extensive network, American Airlines connects you to destinations worldwide with premium comfort and exceptional service.",
    heading: "Fly with American Airlines",
    text: "American Airlines is one of the largest airlines globally, offering a high-quality travel experience. Whether you’re flying business or first class, you’ll enjoy excellent service, top-class amenities, and comfortable seating.",
    subtext: "An airline that offers quality and service.",
    airlineImage: "/american.jpg",
    experienceImage: "/americane.jpg",
    about:
      "American Airlines is a leading carrier, offering flights to a wide range of destinations. With a focus on customer care, American Airlines ensures a comfortable flying experience.",
  },
  {
    id: "etihad",
    airline: "Etihad Airways",
    business: "£2640",
    first: "£3680",

    details:
      "Etihad Airways offers an extraordinary flying experience with luxurious cabins and exceptional service. Whether you're flying business or first class, Etihad’s attention to detail ensures that you receive the highest level of comfort.",
    heading: "Fly with Etihad Airways",
    text: "Etihad Airways is a luxury airline that offers world-class service, luxurious cabins, and exceptional comfort. From excellent dining to superior in-flight entertainment, Etihad provides a five-star experience.",
    subtext: "For travelers who demand luxury.",
    airlineImage: "/etihad.jpg",
    experienceImage: "/etihade.jpg",
    about:
      "Etihad Airways is known for its luxury and exceptional service, providing an outstanding experience for its passengers. With an extensive network and top-class amenities, Etihad is a premier airline choice.",
  },
  {
    id: "air-newzealand",
    airline: "Air New Zealand",
    business: "£2560",
    first: "£3600",

    details:
      "Air New Zealand offers a world-class flying experience with award-winning service and hospitality. From gourmet dining to fully reclining business seats, the airline ensures a seamless journey with premium in-flight entertainment and comfort.",
    heading: "Discover the Beauty of New Zealand",
    text: "Fly with Air New Zealand and enjoy an unparalleled travel experience. Whether for business or leisure, the airline provides exceptional comfort, service, and connections to major global destinations.",
    subtext: "The heart of Kiwi hospitality in the sky.",
    airlineImage: "/an1.jpg",
    experienceImage: "/newzealande.jpg",
    about:
      "Air New Zealand is the flagship carrier of New Zealand, known for its innovation, friendly service, and commitment to sustainability.",
  },
  {
    id: "malaysia-airlines",
    airline: "Malaysia Airlines",
    business: "£2240",
    first: "£3280",

    details:
      "Malaysia Airlines is renowned for its warm hospitality and superior in-flight services. Offering premium comfort, exquisite Malaysian cuisine, and top-tier entertainment, the airline ensures a luxurious journey across Asia, Australia, and beyond.",
    heading: "Experience Malaysian Hospitality",
    text: "Fly with Malaysia Airlines and enjoy a seamless and comfortable journey with world-class service and luxurious cabins.",
    subtext: "Your gateway to Asia and beyond.",
    airlineImage: "/malasiya.jpg",
    experienceImage: "/malasiyae.jpg",
    about:
      "Malaysia Airlines is the national carrier of Malaysia, recognized for its exceptional service and extensive network.",
  },
  {
    id: "garuda-indonesia",
    airline: "Garuda Indonesia",
    business: "£2080",
    first: "£3120",

    details:
      "Garuda Indonesia offers a luxurious and comfortable flying experience with Indonesian hospitality at its finest. From spacious seating to world-class cuisine, every flight is designed for relaxation and enjoyment.",
    heading: "Fly with Indonesia’s Best",
    text: "Enjoy the premium experience of Garuda Indonesia with top-tier service, spacious seating, and award-winning hospitality.",
    subtext: "Bringing Indonesia’s warmth to the skies.",
    airlineImage: "/garuna.jpg",
    experienceImage: "/garudae.jpg",
    about:
      "Garuda Indonesia is the flagship carrier of Indonesia, known for its exceptional service and modern fleet.",
  },
  {
    id: "swiss",
    airline: "Swiss International Air Lines",
    business: "£2400",
    first: "£3760",

    details:
      "Swiss International Air Lines offers a refined flying experience, combining Swiss precision with world-class luxury. From gourmet meals to spacious seating, every journey is a pleasure.",
    heading: "Travel in Swiss Elegance",
    text: "Fly with Swiss and experience comfort, style, and efficiency with an extensive European and international network.",
    subtext: "Swiss quality in the air.",
    airlineImage: "/Swissa.jpg",
    experienceImage: "/swisse.jpg",
    about:
      "Swiss International Air Lines is Switzerland’s flagship airline, providing premium service with a commitment to quality.",
  },
  {
    id: "delta",
    airline: "Delta Air Lines",
    business: "£2560",
    first: "£4000",

    details:
      "Delta Air Lines offers premium services with state-of-the-art cabins, fine dining, and exclusive Sky Club lounges. Whether flying across the U.S. or internationally, Delta ensures a seamless journey.",
    heading: "Fly with Delta, Fly with Comfort",
    text: "Experience superior service, spacious seating, and premium amenities with Delta Air Lines.",
    subtext: "Redefining travel excellence.",
    airlineImage: "/delta.jpeg",
    experienceImage: "/deltae.jpg",
    about:
      "Delta Air Lines is one of the largest airlines in the world, offering extensive domestic and international routes.",
  },
  {
    id: "klm",
    airline: "KLM Royal Dutch Airlines",
    business: "£2480",
    first: "£3840",

    details:
      "KLM Royal Dutch Airlines is known for its exceptional service, spacious cabins, and Dutch hospitality. Offering a seamless travel experience, KLM connects travelers worldwide.",
    heading: "Fly the Dutch Way with KLM",
    text: "Enjoy top-tier service and comfort with KLM, featuring fully reclining seats, gourmet dining, and world-class entertainment.",
    subtext: "A century of excellence in aviation.",
    airlineImage: "/klma.jpg",
    experienceImage: "/klme.jpg",
    about:
      "KLM Royal Dutch Airlines is the national carrier of the Netherlands, providing exceptional service and innovative travel solutions.",
  },
  {
    id: "eva-air",
    airline: "EVA Air",
    business: "£2320",
    first: "£3680",

    details:
      "EVA Air offers a premium flying experience with state-of-the-art aircraft, luxurious seating, and outstanding service. With a strong presence in Asia and global connectivity, EVA Air guarantees a comfortable journey.",
    heading: "Fly in Luxury with EVA Air",
    text: "Experience the best of Asian hospitality with EVA Air, providing a seamless and elegant travel experience.",
    subtext: "Excellence in every flight.",
    airlineImage: "/evaa.jpg",
    experienceImage: "/evae.jpg",
    about:
      "EVA Air is a top-rated Taiwanese airline known for its premium services and cutting-edge technology.",
  },
  {
    id: "ana",
    airline: "All Nippon Airways (ANA)",
    business: "£2800",
    first: "£4160",

    details:
      "All Nippon Airways (ANA) is Japan’s largest airline, offering world-class service, premium comfort, and traditional Japanese hospitality. From exquisite dining to high-tech amenities, ANA ensures a top-tier flying experience.",
    heading: "Experience Japanese Excellence",
    text: "Fly with ANA and enjoy a luxurious and efficient journey, featuring cutting-edge aircraft, superior service, and authentic Japanese cuisine.",
    subtext: "A new standard in travel.",
    airlineImage: "/anaa.jpg",
    experienceImage: "/anae.jpg",
    about:
      "All Nippon Airways (ANA) is Japan’s premier airline, recognized for its top-notch service and advanced fleet.",
  },
];

const AirlinesDetail = () => {
  const { id } = useParams();
  const [selectedDestination, setSelectedDestination] = useState("");

  const airline = airlines.find(
    (airline) => airline.id.toLowerCase() === id.toLowerCase()
  );
  const availableDestinations = airlineDestinations[id] || [];

  useEffect(() => {
    if (availableDestinations.length > 0 && !selectedDestination) {
      setSelectedDestination(availableDestinations[0]);
    }
  }, [id, availableDestinations, selectedDestination]);

  if (!airline) {
    return <h2>Airline not found</h2>;
  }

  const calladmin = () => {
    window.location.href = "tel:02039449931";
  };
  return (
    <>
      <DestinationDeals />
      <div className="text-center p-8">
        <h2 className="text-2xl font-bold mb-4 he">{airline.heading}</h2>
        <p className="het">{airline.text}</p>
      </div>

      <div className="image-sectionn">
        <h2 className="section-headingn">{airline.airline}</h2>
        <img
          src={airline.airlineImage}
          alt={airline.airline}
          className="section-imagen"
        />
      </div>

      <div className="business-flight-container">
        <div className="left-section">
          <h2>Affordable {airline.airline} Business Class Flights</h2>
          <p>{airline.about}</p>
          <p>{airline.details}</p>

          <h3>Why Fly Business Class with {airline.airline}?</h3>
          <img src="/s4.jpg" alt="Business Class Seat" />

          <h4>Superior Comfort Above the Clouds</h4>
          <p>
            Business class offers unmatched comfort and convenience. With
            spacious, fully reclining seats and top-tier entertainment, your
            flight with {" "}
            {airline.airline} will be truly exceptional.
          </p>

          <h3>Fine Dining at 30,000 Feet</h3>
          <p>
            Enjoy complimentary gourmet dining and drinks, including premium
            wines, cocktails, and freshly crafted meals prepared by expert
            chefs.
          </p>

          <h3>Exclusive Privacy on Board</h3>
          <p>
            Business class provides a private, peaceful space where you can
            work, relax, or simply disconnect from distractions during your
            journey.
          </p>

          <h3>Premium Pre-flight Perks</h3>
          <p>
            Enjoy luxury before departure with exclusive lounge access and
            priority airport services designed for a stress-free experience.
          </p>

          <h3>Smooth & Effortless Travel</h3>
          <img src={airline.experienceImage} alt="Travel Experience" />
          <p>
            From fast check-in to priority security clearance and elite lounges,
            {airline.airline} ensures a seamless and hassle-free journey.
          </p>
        </div>

        <div className="right-sectionf">
          <div className="flight-price-section">
            <div className="destination-selector">
              <div className="destination-buttons">
                {availableDestinations.map((destination) => (
                  <button
                    key={destination}
                    onClick={() => setSelectedDestination(destination)}
                    className={`destination-button ${
                      selectedDestination === destination ? "active" : ""
                    }`}
                  >
                    {destination.toUpperCase()}
                  </button>
                ))}
              </div>
            </div>

            <div className="destination-lista">
              {selectedDestination &&
                destinationData[selectedDestination]?.map((cityData, index) => (
                  <div key={index} className="city-card">
                    <h3>{cityData.city}</h3>
                    <p>First Class: From £{cityData.firstClass}</p>
                    <p>Business Class: From £{cityData.businessClass}</p>
                    <p>Premium Economy: From £{cityData.premiumEconomy}</p>
                    <p>Economy: From £{cityData.economy}</p>
                    <Link to={cityData.link}>
                      <button className="get-price-btn">Get Price</button>
                    </Link>
                    <button className="get-price-btn" onClick={calladmin}>
                      Call Now
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AirlinesDetail;
